import React, { useState, useEffect, useContext } from "react";
import BannerSalon from "../../assets/showcases/salon-banner.jpg";
import BannerTrainer from "../../assets/showcases/trainer-banner.png";
import BannerBarber from "../../assets/showcases/barber-banner.png";
import { Avatar, Box, Button, Typography, Grid, Divider } from "@mui/material";
import { useTranslation } from "react-i18next";

import BannerEcommerce from "../../assets/showcases/ecommerce-banner.png";
import BannerRestaurant from "../../assets/showcases/restaurant-banner.png";

import Product1 from "../../assets/showcases/ecommerce/product1.jpg";
import Product2 from "../../assets/showcases/ecommerce/product2.jpg";
import Product3 from "../../assets/showcases/ecommerce/product3.jpg";
import Product4 from "../../assets/showcases/ecommerce/product4.jpg";
import Product5 from "../../assets/showcases/ecommerce/product5.jpg";
import Product6 from "../../assets/showcases/ecommerce/product6.jpg";

import Product10 from "../../assets/showcases/ecommerce/product10.jpg";
import Product11 from "../../assets/showcases/ecommerce/product11.jpg";
import Product12 from "../../assets/showcases/ecommerce/product12.jpg";
import Product13 from "../../assets/showcases/ecommerce/product13.jpg";
import Product14 from "../../assets/showcases/ecommerce/product14.jpg";
import Product15 from "../../assets/showcases/ecommerce/product15.jpg";

import ProductRestaurant1 from "../../assets/showcases/restaurant/product1.JPG";
import ProductRestaurant2 from "../../assets/showcases/restaurant/product2.JPG";
import ProductRestaurant3 from "../../assets/showcases/restaurant/product3.JPG";
import ProductRestaurant4 from "../../assets/showcases/restaurant/product4.JPG";
import ProductRestaurant5 from "../../assets/showcases/restaurant/product5.JPG";
import ProductRestaurant6 from "../../assets/showcases/restaurant/product6.JPG";

import ProductCategories1 from "../../assets/showcases/ecommerce/categories1.jpg";
import ProductCategories2 from "../../assets/showcases/ecommerce/categories2.jpg";
import ProductCategories3 from "../../assets/showcases/ecommerce/categories3.jpg";
import ProductCategories4 from "../../assets/showcases/ecommerce/categories4.jpg";
import ProductCategories5 from "../../assets/showcases/ecommerce/categories5.jpg";
import ProductCategories6 from "../../assets/showcases/ecommerce/categories6.jpg";

import { ArrowForwardIosOutlined } from "@mui/icons-material";
import { CreatorContext } from "../../context/CreatorContext";

import fontIcons from "../../assets/font-glyphs/icons.json";

const Icon = React.memo(({ family, name, color, ...props }) => (
	<span
		style={{
			fontSize: 10,
			fontFamily:
				family === "FontAwesome5"
					? "'FontAwesome5', 'FontAwesome5_Regular', 'FontAwesome5Brands'"
					: family,
			color: color ? color : "#000000",
		}}
		{...props}
	>
		{String.fromCodePoint(fontIcons[family][name])}
	</span>
));

const ShowcaseFavorite = ({
	sector = "ecommerce",
	favorite,
	selectedFavoriteIconType,
	selectedFavoriteIconName,
}) => {
	const { t } = useTranslation();
	const [content, setContent] = useState(null);
	const { creator } = useContext(CreatorContext);

	console.log(favorite);

	useEffect(() => {
		const loadContent = () => {
			switch (sector) {
				case "ecommerce":
					return {
						banner: BannerEcommerce,
						products: [
							{
								name: t("homeProducts.pinkSweater"),
								price: "€17.99",
								image: Product2,
							},
							{
								name: t("homeProducts.oversizePinkSweater"),
								price: "€20.99",
								image: Product4,
							},
							{
								name: t("homeProducts.oversizePinkSweater"),
								price: "€17.99",
								image: Product5,
							},
						],
					};

				case "restaurant":
					return {
						banner: BannerRestaurant,
						products: [
							{
								name: t("menuItems.hamPizza"),
								price: "€8.00",
								image: ProductRestaurant4,
							},
							{
								name: t("menuItems.cheesePizza"),
								price: "€8.00",
								image: ProductRestaurant2,
							},
							{
								name: t("menuItems.vegetarianPizza"),
								price: "€9.50",
								image: ProductRestaurant3,
							},
						],
					};

				default:
					return {};
			}
		};

		setContent(loadContent());
	}, [sector, t]);

	const getTextColorBasedOnBackground = (bgColor) => {
		const r = parseInt(bgColor.substring(1, 3), 16);
		const g = parseInt(bgColor.substring(3, 5), 16);
		const b = parseInt(bgColor.substring(5, 7), 16);
		const brightness = (r * 299 + g * 587 + b * 114) / 1000;
		return brightness > 128 ? "#000000" : "#FFF";
	};

	return (
		<Box
			sx={{
				position: "relative",
				"& *:not(span)": {
					fontFamily: creator.fontFamilyCap + "!important",
				},
			}}
		>
			{content && favorite && favorite.value === "favorite1" && (
				<Box sx={{ padding: 1 }}>
					<Grid container spacing={1}>
						{content.products.map((product, index) => (
							<Grid item xs={6} sm={6} key={index}>
								<Box
									sx={{
										display: "flex",
										flexDirection: "column",
										alignItems: "left",
										overflow: "hidden",
									}}
								>
									<img
										src={product.image}
										alt={product.name}
										style={{
											width: "100%",
											height: "140px",
											objectFit: "cover",
										}}
									/>
									<Typography
										variant="body1"
										sx={{
											fontSize: 8,
											marginTop: 0.5,
											textAlign: "left",
										}}
									>
										{product.name}
									</Typography>
									<Box
										display="flex"
										justifyContent="space-between"
										alignItems="center"
										sx={{}}
									>
										<Typography
											variant="body1"
											sx={{ fontSize: "8px", fontWeight: "bold" }}
										>
											{product.price}
										</Typography>
										<Icon
											family={selectedFavoriteIconType}
											name={selectedFavoriteIconName}
										/>
									</Box>
								</Box>
							</Grid>
						))}
					</Grid>
				</Box>
			)}
			{content && favorite && favorite.value === "favorite2" && (
				<Box sx={{ padding: 1 }}>
					<Grid container spacing={1}>
						{content.products.map((product, index) => (
							<Grid item xs={6} sm={6} key={index}>
								<Box
									sx={{
										display: "flex",
										flexDirection: "column",
										alignItems: "left",
										overflow: "hidden",
										justifyContent: "center",
									}}
								>
									<Box
										sx={{
											display: "flex",
											justifyContent: "center",
										}}
									>
										<img
											src={product.image}
											alt={product.name}
											style={{
												width: "70px",
												height: "auto",
												objectFit: "cover",
												borderRadius: "50%",
												aspectRatio: 1,
											}}
										/>
									</Box>
									<Typography
										variant="body1"
										sx={{
											fontSize: 8,
											marginTop: 0.5,
											textAlign: "left",
										}}
									>
										{product.name}
									</Typography>
									<Box
										display="flex"
										justifyContent="space-between"
										alignItems="center"
										sx={{}}
									>
										<Typography
											variant="body1"
											sx={{ fontSize: "8px", fontWeight: "bold" }}
										>
											{product.price}
										</Typography>
										<Icon
											family={selectedFavoriteIconType}
											name={selectedFavoriteIconName}
										/>
									</Box>
								</Box>
							</Grid>
						))}
					</Grid>
				</Box>
			)}
			{content && favorite && favorite.value === "favorite3" && (
				<Box sx={{ padding: 1 }}>
					<Grid container spacing={1}>
						{content.products.map((product, index) => (
							<Grid item xs={6} sm={6} key={index}>
								<Box
									sx={{
										display: "flex",
										flexDirection: "column",
										alignItems: "left",
										overflow: "hidden",
									}}
								>
									<img
										src={product.image}
										alt={product.name}
										style={{
											width: "100%",
											aspectRatio: 1,
											objectFit: "cover",
										}}
									/>
									<Typography
										variant="body1"
										sx={{
											fontSize: 8,
											marginTop: 0.5,
											textAlign: "left",
										}}
									>
										{product.name}
									</Typography>
									<Box
										display="flex"
										justifyContent="space-between"
										alignItems="center"
										sx={{}}
									>
										<Typography
											variant="body1"
											sx={{ fontSize: "8px", fontWeight: "bold" }}
										>
											{product.price}
										</Typography>
										<Icon
											family={selectedFavoriteIconType}
											name={selectedFavoriteIconName}
										/>
									</Box>
								</Box>
							</Grid>
						))}
					</Grid>
				</Box>
			)}
			{content && favorite && favorite.value === "favorite4" && (
				<Box sx={{ padding: 1 }}>
					<Grid container spacing={1}>
						{content.products.map((product, index) => (
							<Grid item xs={6} sm={6} key={index}>
								<Box
									sx={{
										display: "flex",
										flexDirection: "column",
										alignItems: "left",
										overflow: "hidden",
									}}
								>
									<img
										src={product.image}
										alt={product.name}
										style={{
											width: "100%",
											height: "120px",
											objectFit: "cover",
											borderRadius: 12,
										}}
									/>
									<Typography
										variant="body1"
										sx={{
											fontSize: 8,
											marginTop: 0.5,
											textAlign: "left",
										}}
									>
										{product.name}
									</Typography>
									<Box
										display="flex"
										justifyContent="space-between"
										alignItems="center"
										sx={{}}
									>
										<Typography
											variant="body1"
											sx={{ fontSize: "8px", fontWeight: "bold" }}
										>
											{product.price}
										</Typography>
										<Icon
											family={selectedFavoriteIconType}
											name={selectedFavoriteIconName}
										/>
									</Box>
								</Box>
							</Grid>
						))}
					</Grid>
				</Box>
			)}
			{content && favorite && favorite.value === "favorite5" && (
				<Box sx={{ padding: 1 }}>
					<Grid container spacing={1}>
						{content.products.map((product, index) => (
							<Grid item xs={12} sm={12} key={index}>
								<Box
									sx={{
										display: "flex",
										flexDirection: "column",
										alignItems: "left",
										overflow: "hidden",
									}}
								>
									<img
										src={product.image}
										alt={product.name}
										style={{
											width: "100%",
											height: "180px",
											objectFit: "cover",
										}}
									/>
									<Typography
										variant="body1"
										sx={{
											fontSize: 8,
											marginTop: 0.5,
											textAlign: "left",
										}}
									>
										{product.name}
									</Typography>
									<Box
										display="flex"
										justifyContent="space-between"
										alignItems="center"
										sx={{}}
									>
										<Typography
											variant="body1"
											sx={{ fontSize: "8px", fontWeight: "bold" }}
										>
											{product.price}
										</Typography>
										<Icon
											family={selectedFavoriteIconType}
											name={selectedFavoriteIconName}
										/>
									</Box>
								</Box>
							</Grid>
						))}
					</Grid>
				</Box>
			)}
			{content && favorite && favorite.value === "favorite6" && (
				<Box sx={{}}>
					<Grid container>
						{content.products.map((product, index) => (
							<Grid item xs={6} sm={6} key={index}>
								<Box
									sx={{
										display: "flex",
										flexDirection: "column",
										alignItems: "left",
										overflow: "hidden",
									}}
								>
									<img
										src={product.image}
										alt={product.name}
										style={{
											width: "100%",
											aspectRatio: 1,
											objectFit: "cover",
										}}
									/>
									<Box sx={{ padding: 1, paddingTop: 0.5 }}>
										<Typography
											variant="body1"
											sx={{
												fontSize: 8,
												marginTop: 0.5,
												textAlign: "left",
											}}
										>
											{product.name}
										</Typography>
										<Box
											display="flex"
											justifyContent="space-between"
											alignItems="center"
											sx={{}}
										>
											<Typography
												variant="body1"
												sx={{ fontSize: "8px", fontWeight: "bold" }}
											>
												{product.price}
											</Typography>
											<Icon
												family={selectedFavoriteIconType}
												name={selectedFavoriteIconName}
											/>
										</Box>
									</Box>
								</Box>
							</Grid>
						))}
					</Grid>
				</Box>
			)}
		</Box>
	);
};

export default ShowcaseFavorite;
